module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"buildingsCount":"Anzahl Liegenschaften","noExistingBuildings":"Keine Bestandesliegenschaften","xUnit":"Liegenschaften","xUnitEbf":"m²","groupByKeys":{"dataquality":"Datenqualität"}}}')
  delete Component.options._Ctor
}
